import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-suppliers-bulk-actions',
  templateUrl: './suppliers-bulk-actions.component.html',
  styleUrls: ['./suppliers-bulk-actions.component.css'],
})
export class SuppliersBulkActionsComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit() {}

  newSupplier() {
    this.router.navigate(['inventory', 'suppliers', 'new']);
  }
}
